/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import logo from 'assets/CC_Logos_Logo_V2.svg';

// CC Logos - Logo wide.svg';
// 'assets/Logo_updated.svg';
import { Menu } from 'components/TopicMenu/Menu';
import { VisuallyHidden } from 'components/UI/VisuallyHidden';
import { Fragment as _, useCallback, useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import isIE from 'services/isIE';
import { colors, getButtonFocus, values } from 'styles/variables';
import BackBtn from 'components/Header/BackBtn';
import ProgressBar from 'components/Header/ProgressBar';
const { lPink, lGrey0 } = colors;
const { headerHeight } = values;

interface IColumn {
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | undefined;
  children: any;
}

const Column = ({ children, justifyContent = undefined }: IColumn) => {
  return (
    <div
      css={css({
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        ...(justifyContent && {
          justifyContent,
        }),
        height: '100%',
      })}
    >
      {children}
    </div>
  );
};

export const HeaderLayout = (props) => {
  const {
    headerRef,
    height,
    responsiveHeight,
    backButton,
    currentTopicIndex,
    topics,
    headerTextColor,
    topicName,
    currentTopicName,
    includeLogo = true,
    headerLogo,
    progressBar,
    topicMenu,
    menu,
    setMenuState,
    background,
    Burger,
  } = props;

  return (
    <header
      key={`header-height-${height}`}
      ref={(node) => {
        if (headerRef) {
          headerRef(node);
        }
      }}
      aria-label="Module header"
      css={css({
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height,
        zIndex: 1,

        '@media (max-width: 480px)': {
          height: responsiveHeight,
        },
      })}
    >
      {background}
      <div
        css={css({
          position: 'relative',
          display: 'flex',
          width: '100%',
          height: 70,
          padding: '10px 30px',
          zIndex: 2,

          '@media (max-width: 480px)': {
            height: 50,
            padding: '5px 15px',
          },
        })}
      >
        <Column>
          {backButton && (
            <BackBtn
              key={currentTopicIndex}
              currentTopic={topics[currentTopicIndex]}
              topics={topics}
              color={headerTextColor}
              outline={true}
            />
          )}

          {topicName && (
            <div
              css={css({
                marginLeft: backButton ? 10 : 0,
                color: headerTextColor,
                '@media (max-width: 480px)': {
                  display: 'none',
                },
              })}
            >
              <VisuallyHidden>Current Topic: </VisuallyHidden>
              {currentTopicName}
            </div>
          )}
        </Column>

        {includeLogo && (
          <Column>
            <div
              css={css({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',

                '@media (max-width: 480px)': {
                  minWidth: 'calc(100vw - 100px)',
                },
              })}
            >
              <img
                src={headerLogo || logo}
                alt=""
                css={css({
                  position: 'relative',
                  maxHeight: '100%',
                })}
              />
            </div>
          </Column>
        )}

        <Column justifyContent="flex-end">
          <div
            css={css({
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'flex-end',
            })}
          >
            {progressBar && (
              <div
                css={css`
                  flex: 1;
                  max-width: 250px;
                  margin-right: ${topicMenu ? '30' : '0'}px;

                  @media (max-width: 480px) {
                    display: none;
                  }
                `}
              >
                <ProgressBar color={headerTextColor} />
              </div>
            )}

            {topicMenu && (
              <_>
                <Burger
                  color={headerTextColor}
                  onClick={() => {
                    setMenuState(true);
                  }}
                />

                <div
                  css={css({
                    position: 'absolute',
                    right: -30,
                    top: 0,
                  })}
                >
                  <Menu
                    menu={menu}
                    close={() => {
                      // console.log('close');
                      setMenuState(false);
                    }}
                  />
                </div>
              </_>
            )}
          </div>
        </Column>
      </div>
    </header>
  );
};
